import Reflux from 'reflux';
import { actions } from 'actions';


var TimezoneStore = Reflux.createStore({
  init: function() {
    this.listenTo(actions.getTimezones, this.getTimezones);
  },
  getTimezones: function() {
    fetch('/rest/v2/supplier/timezones').then((response) => {
      return response.json();
    }).then(data => {
      this.trigger(data);
    });
  }
})

export { TimezoneStore };
